import globalObj from '../utils/globalObj'
import { showLoading, hideLoading } from '../utils/loading'
import restMessage from '../utils/resetMessage'

export default {
    install(app) {
        app.config.globalProperties.$globalObj = globalObj;
        app.config.globalProperties.$showLoading = showLoading;
        app.config.globalProperties.$hideLoading = hideLoading;
        app.config.globalProperties.$message = restMessage;
    }
}